import { render, staticRenderFns } from "./navgateOther.vue?vue&type=template&id=6d1327d9"
import script from "./navgateOther.vue?vue&type=script&lang=js"
export * from "./navgateOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports